const filesExtension = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  csv: 'text/csv',
}

type FilesExtension = keyof typeof filesExtension

export const donwloadFile = async (data: any, extension: FilesExtension) => {
  const currentDate = new Date().toLocaleString().replace(/[/:, ]/g, '')
  const hash = generateHash()

  const blob = new Blob([data], {type: filesExtension[extension]})
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `reporte-${currentDate}${hash}.${extension}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const generateHash = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length

  return Array.from({length: 8}, () =>
    characters.charAt(Math.floor(Math.random() * charactersLength))
  ).join('')
}
